<template>
  <div class="wh100">
    <el-dialog
      :visible.sync="dialogVisible"
      width="80%"
      height=""
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <h3>请验证身份信息</h3>
      <span class="spanStyle">身份证后六位：</span>
      <label for="code">
        <ul class="security-code-container">
          <li
            class="field-wrap"
            :class="{ on: seat == index }"
            v-for="(item, index) in list"
            :key="index"
            @click="onClick(index)"
          >
            <i class="char-field">{{ value[index] || placeholder }}</i>
          </li>
        </ul>
      </label>
      <input
        ref="input"
        class="input-code"
        @keyup="keyup($event)"
        @keydown="keydown($event)"
        v-model="value"
        id="code"
        type="text"
        :maxlength="number"
        @touchstart="keyup($event)"
        @touchend="keydown($event)"
      />
      <p>提示：十分钟内只能验证五次身份信息。</p>
      <div class="tar">
        <el-button type="danger" @click="onClean">重置</el-button>
        <el-button type="primary" @click="handleClose">验证</el-button>
      </div>
    </el-dialog>
    <div v-if="!dialogVisible" class="lawyersLetter">
      <h3 class="cw">{{ titleOfLegalLetter }}</h3>
      <!-- <pdf :src="fileUrl"></pdf> -->
      <div class="box-scale" v-if="fileExtension === 'pdf'">
        <vue-office-pdf :src="fileUrl" class="docx-calss" />
      </div>
      <div
        class="box-scale"
        v-if="fileExtension === 'docx' || fileExtension === 'doc'"
      >
        <vue-office-docx :src="fileUrl" class="docx-calss" />
      </div>
      <!-- <iframe :src="fileUrl" frameborder="0" class="iframeStyle"></iframe> -->
    </div>
  </div>
</template>

<script>
import VueOfficePdf from '@vue-office/pdf';
import VueOfficeDocx from '@vue-office/docx';
// import pdf from 'vue-pdf';
import { apiPostCheckLawyerInfo, apiGetdelete } from '@/api/id-card-validate';
import { decryption } from '@/utils/aes-encryption-and-eecryption';
export default {
  name: 'validate-code',
  components: {
    VueOfficePdf,
    VueOfficeDocx,
    // pdf,
  },
  props: {
    number: {
      type: Number,
      default: 6,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      fileUrl: '',
      value: '',
      seat: -1,
      titleOfLegalLetter: '',
      list: '',
      fileId: '',
      fileExtension: '',
      dialogVisible: true,
    };
  },
  created() {
    this.list = new Array(this.number);
    const urlParams = new URLSearchParams(window.location.search);
    this.fileId = urlParams.get('id'); // 'key'是要获取的参数名
    // const dd =
    //   '+5Rfb3SlPGz+GAc5A1h9TtiHwFLIOguCnJOAGv82CFENygec5f9TyxZ2+oUwDt9qIlqQCa3x2RXRK6ARtRNxTCctK3UoyDEYdy1f16Ae81U=';
    // console.log(decryption(dd));
  },
  methods: {
    hideKeyboard() {
      // 输入完成隐藏键盘
      document.activeElement.blur(); // ios隐藏键盘
      this.$refs.input.blur(); // android隐藏键盘
    },
    keydown(e) {
      //当按下按键时
      console.log(e);
      //alert(JSON.stringify(e))
    },
    keyup() {
      //按键松开时运行
      this.seat += 1;
      this.$refs.input.value = this.value;
      if (this.value.length >= this.number) {
        this.hideKeyboard();
        this.seat = this.number;
      }
      this.handleSubmit();
    },
    handleSubmit() {
      //返回信息
      this.$emit('returnresult', this.value);
    },
    onClean() {
      //清除
      this.value = '';
      this.seat = -1;
    },
    handleClose() {
      const data = {
        id: this.fileId,
        idNumber: this.value,
      };
      apiPostCheckLawyerInfo(data).then((res) => {
        console.log(res);
        if (res.data.ok) {
          const url = decryption(res.data.data.url);
          this.fileExtension = url.split('.').pop().toLowerCase();
          this.fileUrl = url;
          const title = decryption(res.data.data.title);
          this.titleOfLegalLetter = title;
          this.$message.success('验证成功，请预览律师函！');
          this.dialogVisible = false;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    onClick(index) {
      //点击
      this.seat = index;
    },
    handleBeforeUnload() {
      const params = {
        id: this.fileId,
      };
      apiGetdelete(params).then((res) => {
        console.log(res);
      });
    },
  },
  mounted() {
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  },
};
</script>

<style scoped lang="less">
.cw {
  color: white;
  margin: 0 0 10px 0;
  font-size: 16px;
  text-align: center;
}
.lawyersLetter {
  width: 96%;
  height: 96vh;
  box-sizing: border-box;
  padding: 20px;
  margin: 2vh auto;
  // background: #fff;
  border-radius: 20px;
}
.iframeStyle {
  width: 100%;
  height: 93%;
  border-radius: 15px;
}
.spanStyle {
  display: inline-block;
  width: 100%;
  text-align: left;
}
.security-code-container {
  margin: 0;
  padding: 20px 0;
  display: flex;
  justify-content: center;
  .field-wrap {
    list-style: none;
    display: block;
    border: 1px solid #eee;
    height: 30px;
    width: 30px;
    line-height: 30px;
    font-size: 18px;
    text-align: center;
    overflow: hidden;
    background-color: #fff;
    margin-right: 5px;
    .char-field {
      font-style: normal;
    }
    &.on {
      border: 1px solid #0e88ef;
    }
  }
}
.input-code {
  width: 100%;
  height: 30px;
  position: absolute;
  left: -999999999999px;
  opacity: 0;
  z-index: -1;
}
.clean {
  width: 100%;
  box-sizing: border-box;
  text-align: right;
  color: #0e88ef;
  font-size: 12px;
  padding: 0 10px;
}
.box-scale {
  transform: scale(1);
  transform-origin: center top; /*设置缩放中心点*/
  transition: 0.2s;
  width: 100%;
  height: 100%;
}
.docx-calss {
  height: 100%;
}
::v-deep {
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 10px 20px;
  }
}
.wh100 {
  width: 100%;
  height: 100%;
}
/* 这块是处理边上的灰边 */
:deep(.vue-office-pdf-wrapper) {
  background-color: transparent !important;
  width: 100% !important;
  padding: 0px !important;
  height: 97% !important;
}
:deep(.vue-office-pdf-wrapper canvas) {
  // width: 100% !important;
  padding: 10px !important;
  box-sizing: border-box;
  background-color: #fff !important;
  border: 10px solid #a9a5a5;
}
</style>
